import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user expands or collapses nested board content',
  name: 'expand_nested_content',
  params: [
    {
      description: 'Whether nested board content was expanded or collapsed',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['expand', 'collapse'],
    },
    {
      description: 'The id of the board where nested content was toggled',
      name: 'board_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
